import {useState, useEffect} from 'react'
import {KTSVG} from '../../../../_metronic/helpers'

import {useIntl} from 'react-intl'

import React from 'react'

import TravelManager from './TravelManager'
import TravelHR from './TravelHR'
import TravelFinance from './TravelFinance'
import TravelDesk from './TravelDesk'
import useApiCall from '../../custom_hooks/useApiCall'
import {defaultProfileImage} from '../../core'

const TeamTripsDrawer = (tripsData: any) => {
  const intl = useIntl()
  const {props}: any = tripsData
  const {data, fetchData, isLoading}: any | null = useApiCall(
    `/travel/request/${props?.request_id}`
  )
  let travelData = data && data[0]

  const hrDetails = {
    manager_reviewed_status: travelData?.manager_reviewed_status || '',
    hr_review_comments: travelData?.hr_review_comments || '',
    hr_reviewed_status: travelData?.hr_reviewed_status || '',
    fetchData: fetchData,
    travelfetchdata: props?.fetchData,
    request_id: travelData?.request_id,
  }

  const traveldeskDetails = {
    traveldesk_reviewed_status: travelData?.traveldesk_reviewed_status || '',
    traveldesk_review_comments: travelData?.traveldesk_review_comments || '',
    manager_reviewed_status: travelData?.manager_reviewed_status || '',

    hr_reviewed_status: travelData?.hr_reviewed_status || '',
    fetchData: fetchData,
    travelfetchdata: props?.fetchData,
    request_id: travelData?.request_id,
  }

  const ManagerDetails = {
    manager_reviewed_status: travelData?.manager_reviewed_status || '',
    manager_reviewer_comments: travelData?.manager_reviewer_comments || '',
    fetchData: fetchData,
    travelfetchdata: props?.fetchData,
    request_id: travelData?.request_id,
  }
  const FinanceDetails = {
    manager_reviewed_status: travelData?.manager_reviewed_status || '',
    finance_reviewed_status: travelData?.finance_reviewed_status || '',
    finance_review_comments: travelData?.finance_review_comments || '',
    hr_reviewed_status: travelData?.hr_reviewed_status || '',
    fetchData: fetchData,
    travelfetchdata: props?.fetchData,
    request_id: travelData?.request_id,
  }

  return (
    <div className='card shadow-none rounded-0'>
      <div>
        <div className='card-header' id='side_activities_header'>
          <h3 className='card-title fw-bolder text-dark'>
            {intl.formatMessage({id: 'LABEL.TRAVEL_REQUESTS'})}
          </h3>
          <div className='card-toolbar '>
            <React.Fragment>
              <div className='btn btn-icon btn-sm btn-active-danger' id='side_activities_close'>
                <KTSVG
                  path='/media/icons/duotune/arrows/arr061.svg'
                  className='svg-icon svg-icon-2x'
                />
              </div>
            </React.Fragment>
          </div>
        </div>

        <div className='card-body position-relative' id='side_activities_body'>
          <div>
            <div
              id='side_activities_scroll'
              className='position-relative scroll-y me-n5 pe-5 w-400px'
              data-kt-scroll='true'
              data-kt-scroll-height='auto'
              data-kt-scroll-wrappers='#side_activities_body'
              data-kt-scroll-dependencies='#side_activities_header, #side_activities_footer'
              data-kt-scroll-offset='5px'
            >
              {isLoading ? (
                <div className='card h-350px'>
                  <div className='m-auto d-flex flex-column align-items-center'>
                    <div className='spinner-border spinner-primary mr-15'></div>
                  </div>
                </div>
              ) : (
                <>
                  <div className='d-flex'>
                    <div className='d-flex'>
                      <img
                        src={
                          travelData?.employee_profile_pic
                            ? travelData?.employee_profile_pic
                            : defaultProfileImage
                        }
                        alt=''
                        className='activity-img rounded w-60px  h-60px me-2'
                      />
                      <div className=''>
                        <a href='#' className='text-dark fw-bold text-hover-primary fs-5'>
                          {travelData?.first_name &&
                          travelData?.middle_name &&
                          travelData?.last_name
                            ? `${travelData?.first_name} ${travelData?.middle_name} ${travelData?.last_name}`
                            : travelData?.first_name && travelData?.last_name
                            ? `${travelData?.first_name} ${travelData?.last_name}`
                            : '-'}
                        </a>
                        <br />
                        <a href='#' className='text-muted fw-bold text-hover-primary fs-7'>
                          {travelData?.employee_code ? travelData.employee_code : '-'}
                        </a>
                        <br />
                        <a href='#' className='text-muted fw-bold text-hover-primary fs-7'>
                          {travelData?.job_title ? travelData.job_title : '-'}
                        </a>
                        <br />
                        {/* <a href='#' className='text-muted fw-bold text-hover-primary fs-7'>
                          {travelData?.department_name}
                        </a> */}
                        <br />
                      </div>
                    </div>
                  </div>
                  <h5 className='mt-1 text-dark'>Basic Information</h5>
                  <hr className='text-dark mt-1' />
                  <div className='row mb-2'>
                    <label className='col-lg-4 fw-bold text-muted'>
                      {intl.formatMessage({id: 'LABEL.PROJECT_NAME'})}
                    </label>
                    <div className='col-lg-8'>
                      <span className='fw-bolder fs-6 text-dark text-hover-primary default-cursor'>
                        {travelData?.project_name}
                      </span>
                    </div>
                  </div>
                  <div className='row mb-2'>
                    <label className='col-lg-4 fw-bold text-muted'>
                      {intl.formatMessage({id: 'LABEL.MODE_OF_TRANSPORT'})}
                    </label>
                    <div className='col-lg-8'>
                      <span className='fw-bolder fs-6 text-dark text-hover-primary default-cursor'>
                        {travelData?.mode_of_transport}
                      </span>
                    </div>
                  </div>
                  <div className='row mb-2'>
                    <label className='col-lg-4 fw-bold text-muted'>
                      {' '}
                      {intl.formatMessage({id: 'LABEL.PLACE_OF_VISIT'})}
                    </label>
                    <div className='col-lg-8'>
                      <span className='fw-bolder fs-6 text-dark text-hover-primary default-cursor'>
                        {travelData?.place_of_visit}
                      </span>
                    </div>
                  </div>
                  <h5 className='mt-4 text-dark'> {intl.formatMessage({id: 'LABEL.WORKFLOW'})}</h5>
                  <hr className='text-dark mt-2' />
                  <div className='card-body position-relative p-0' id='kt_activities_body'>
                    <div className='timeline'>
                      <TravelManager managerDetails={ManagerDetails} />

                      <TravelHR hrDetails={hrDetails} />

                      <TravelDesk traveldeskDetails={traveldeskDetails} />
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TeamTripsDrawer
